import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-6af95509"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "description"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div data-v-6af95509><img src=\"" + _imports_0 + "\" alt=\"DoctorApp\" data-v-6af95509><h1 data-v-6af95509><b style=\"color:black;\" data-v-6af95509>Doctor</b><b data-v-6af95509>App</b><br data-v-6af95509><em data-v-6af95509>Înscriere medic </em></h1></div><p data-v-6af95509> Descoperiți funcționalitățile <strong data-v-6af95509>DoctorApp</strong> și începeți să oferiți consultații medicale online într-un mediu sigur și profesionist. </p><p data-v-6af95509> Pentru a vă înscrie, completați formularul de mai jos. În procesul de creare a contului, vă vom solicita următoarele documente: </p><ul class=\"checklist space-y-1 pl-4 text-gray-700\" data-v-6af95509><li data-v-6af95509>Carte de identitate</li><li data-v-6af95509>Aviz de liberă practică</li><li data-v-6af95509>Certificat de membru în Colegiul Medicilor vizat pe anul în curs</li><li data-v-6af95509>Datele de identificare fiscală ale PFI sau SRL-ului pe care facturați</li><li data-v-6af95509>Contul bancar în care se vor efectua plățile consultațiilor</li></ul><p data-v-6af95509> După completarea formularului, un reprezentant <strong data-v-6af95509>DoctorApp</strong> vă va contacta în cel mai scurt timp pentru finalizarea procesului de înregistrare. </p>", 5)
const _hoisted_8 = [
  _hoisted_3
]
const _hoisted_9 = {
  key: 1,
  class: "description",
  style: {
        width: '50%',
        textAlign: 'center',
        padding: '2rem 0',
        borderRadius: '5px',
        margin: '2rem',
      }
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, [
    /*#__PURE__*/_createElementVNode("em", null, "Avem"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("b", null, "vești bune!")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, " Cererea a fost înregistrată. În scurt timp veți fi contactat de către un administrator DoctorApp pentru finaliza procesul de înregistrare în aplicație. Va mulțumim! ")
], -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 2,
  class: "registration-form"
}
const _hoisted_13 = { class: "form-group" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "firstName" }, [
  /*#__PURE__*/_createTextVNode("Nume: "),
  /*#__PURE__*/_createElementVNode("span", null, "*")
], -1))
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "lastName" }, [
  /*#__PURE__*/_createTextVNode("Prenume: "),
  /*#__PURE__*/_createElementVNode("span", null, "*")
], -1))
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "specialty" }, [
  /*#__PURE__*/_createTextVNode("Specializare: "),
  /*#__PURE__*/_createElementVNode("span", null, "*")
], -1))
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "phone" }, [
  /*#__PURE__*/_createTextVNode("Telefon: "),
  /*#__PURE__*/_createElementVNode("span", null, "*")
], -1))
const _hoisted_21 = { class: "form-group" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "email" }, [
  /*#__PURE__*/_createTextVNode("Email: "),
  /*#__PURE__*/_createElementVNode("span", null, "*")
], -1))
const _hoisted_23 = { class: "form-group termsandcond" }
const _hoisted_24 = {
  key: 0,
  class: "form-group"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Unable to validate captcha", -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["innerHTML"]
const _hoisted_29 = ["innerHTML"]

import { FormValidator } from "@/validators/FormValidator";
import RegisterRequestService from "@/services/RegisterRequestService";
import { ref, Ref, watch, inject, onMounted } from "vue";
import { useReCaptcha } from "vue-recaptcha-v3";

import { useToast } from "primevue/usetoast";
import { RegisterRequest } from "@/interfaces/RegisterRequest";
import Dialog from "primevue/dialog";

import { AppConfigServiceCtx } from "@/api";
import AppConfigService from "@/services/AppConfigService";
import { TermsAndConditions } from "@/interfaces/TermsAndConditions";
import { PlatformPolicies } from "@/interfaces/PlatformPolicies";


export default /*#__PURE__*/_defineComponent({
  __name: 'RequestAccountView',
  setup(__props) {

const toast = useToast();
const recaptcha = useReCaptcha();
const termsContent = ref();
const policiesContent = ref();

const appConfigService: AppConfigService | undefined =
  inject(AppConfigServiceCtx);
const registerRequest: Ref<RegisterRequest> = ref({} as RegisterRequest);

const errors = ref({
  firstName: null as string | null,
  lastName: null as string | null,
  specialty: null as string | null,
  phone: null as string | null,
  email: null as string | null,
});

const isSubmitting = ref(true);
const registered = ref(false);
const recaptchaError = ref(false);
const termsnandconditions = ref(false);
const termsVisible = ref(false);
const policiesVisible = ref(false);

watch(termsnandconditions, (newValue) => {
  isSubmitting.value = !newValue;
});

const showTerms = () => {
  termsVisible.value = true;
};

const showPolicies = () => {
  policiesVisible.value = true;
};

const handleSubmit = async () => {
  if (validateForm()) {
    const captchaToken = await recaptcha?.executeRecaptcha("login");
    isSubmitting.value = true;
    if (!captchaToken) {
      recaptchaError.value = true;
      isSubmitting.value = false;
      return;
    }
    try {
      const registeredRequest: RegisterRequest =
        await RegisterRequestService.saveRegisterRequest(registerRequest.value);
      if (registeredRequest && registeredRequest.id) {
        registered.value = true;

        setTimeout(() => {
          window.location.href = "https://doctorapp.ro";
        }, 5000);
      } else {
        showError("Nu s-a putut trimite cererea de inregistrare.");
      }
    } catch {
      showError("Nu s-a putut trimite cererea de inregistrare.");
    }
  }
};

const showError = (message: string): void => {
  toast.add({
    severity: "error",
    summary: "A aparut o eroare!",
    detail: message,
    life: 3000,
  });
};

function validateForm() {
  let valid = true;
  errors.value.firstName = registerRequest.value?.firstName
    ? null
    : "Acest camp este obligatoriu";
  errors.value.lastName = registerRequest.value?.lastName
    ? null
    : "Acest camp este obligatoriu";
  errors.value.specialty = registerRequest.value?.specialty
    ? null
    : "Acest camp este obligatoriu";
  errors.value.phone = validatePhone(registerRequest.value?.phone)
    ? null
    : "Numarul de telefon nu este valid";
  errors.value.email = validateEmail(registerRequest.value?.email)
    ? null
    : "Adresa de email nu este valida";

  Object.values(errors.value).forEach((error) => {
    if (error) valid = false;
  });

  return valid;
}

function validateEmail(email: string) {
  return FormValidator.isValidEmail(email);
}

function validatePhone(phone: string) {
  return FormValidator.isValidPhone(phone);
}

onMounted(async () => {
  const tc: TermsAndConditions | undefined =
    await appConfigService?.fetchTermsAndConditionsForDoctor();
  if (tc != null && tc.content) {
    termsContent.value = tc.content;
  }
  const pc: PlatformPolicies | undefined =
    await appConfigService?.fetchPlatformPoliciesForDoctor();
  if (pc != null && pc.content) {
    policiesContent.value = pc.content;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!registered.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_8))
        : _createCommentVNode("", true),
      (registered.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
        : _createCommentVNode("", true),
      (!registered.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("form", {
              onSubmit: _withModifiers(handleSubmit, ["prevent"])
            }, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("input", {
                  id: "firstName",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((registerRequest.value.firstName) = $event)),
                  type: "text"
                }, null, 512), [
                  [_vModelText, registerRequest.value.firstName]
                ]),
                _createElementVNode("span", null, _toDisplayString(errors.value.firstName), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _withDirectives(_createElementVNode("input", {
                  id: "lastName",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((registerRequest.value.lastName) = $event)),
                  type: "text"
                }, null, 512), [
                  [_vModelText, registerRequest.value.lastName]
                ]),
                _createElementVNode("span", null, _toDisplayString(errors.value.lastName), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _withDirectives(_createElementVNode("input", {
                  id: "specialty",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((registerRequest.value.specialty) = $event)),
                  type: "text"
                }, null, 512), [
                  [_vModelText, registerRequest.value.specialty]
                ]),
                _createElementVNode("span", null, _toDisplayString(errors.value.specialty), 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _withDirectives(_createElementVNode("input", {
                  id: "phone",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((registerRequest.value.phone) = $event)),
                  type: "text"
                }, null, 512), [
                  [_vModelText, registerRequest.value.phone]
                ]),
                _createElementVNode("span", null, _toDisplayString(errors.value.phone), 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _withDirectives(_createElementVNode("input", {
                  id: "email",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((registerRequest.value.email) = $event)),
                  type: "text"
                }, null, 512), [
                  [_vModelText, registerRequest.value.email]
                ]),
                _createElementVNode("span", null, _toDisplayString(errors.value.email), 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _withDirectives(_createElementVNode("input", {
                  id: "email",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((termsnandconditions).value = $event)),
                  type: "checkbox"
                }, null, 512), [
                  [_vModelCheckbox, termsnandconditions.value]
                ]),
                _createTextVNode(" Sunt de acord cu "),
                _createElementVNode("span", {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (showPolicies())),
                  class: "terms"
                }, "Politicile platformei"),
                _createTextVNode(" și "),
                _createElementVNode("span", {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (showTerms())),
                  class: "terms"
                }, "Termenii și condițiile"),
                _createTextVNode(". ")
              ]),
              (recaptchaError.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
                : _createCommentVNode("", true),
              _createElementVNode("button", {
                type: "submit",
                disabled: isSubmitting.value
              }, "Trimiteți", 8, _hoisted_27)
            ], 32)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Dialog), {
      visible: termsVisible.value,
      "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => ((termsVisible).value = $event)),
      modal: "",
      header: "TERMENI ȘI CONDIȚII",
      style: { width: '50rem' },
      breakpoints: { '1199px': '75vw', '575px': '90vw' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", { innerHTML: termsContent.value }, null, 8, _hoisted_28)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_unref(Dialog), {
      visible: policiesVisible.value,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => ((policiesVisible).value = $event)),
      modal: "",
      header: "POLITICI PLATFORMĂ",
      style: { width: '50rem' },
      breakpoints: { '1199px': '75vw', '575px': '90vw' }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", { innerHTML: policiesContent.value }, null, 8, _hoisted_29)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}
}

})